import React from 'react';
import * as Images from '../assets';

const SplashScreen = () => {
  return (
    <div>
      <div class="flex flex-col gap-4 justify-center items-center bg-[var(--blue)] h-screen">
        <img alt="logo" src={Images.AppLogo} className="w-[200px]" />
        <div className="flex gap-2 items-center">
          <div class="h-8 w-8 bg-[var(--dark-blue)] rounded-full animate-bounce [animation-delay:-0.3s]"></div>
          <div class="h-8 w-8 bg-[var(--dark-blue)] rounded-full animate-bounce [animation-delay:-0.15s]"></div>
          <div class="h-8 w-8 bg-[var(--dark-blue)] rounded-full animate-bounce"></div>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
